import axios from 'axios';
import {CountriesResponseModel,AllCountriesResponseModel,CountryDto, CountriesDropDownDataResponseModel, CountriesDropDownData, CountryRequest, CertificatesDto, CommonResponse} from '@gtpl/shared-models/masters';
import connection from '../../../hrms/src/lib/connection';
import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { PayrollComponentsDto } from 'libs/shared-models/hrms/src/lib/payroll-process/payroll-components.dto';
import { EmailModel, PayRollMonthDto, PayRollRequest, PayslipGenerationReq } from '@gtpl/shared-models/hrms';
import { employeeIdRequest } from '@gtpl/shared-models/gtpl';


export class PayrollProcessServices {
URL = connection.DEPLOY_URL + '/payroll';

  async createPayroll(createDto: PayrollComponentsDto): Promise<CommonResponse> {
      return await axios.post(this.URL + '/createPayroll',createDto)
          .then(res => {
              return res.data
          })
  }


  async generatePayRoll(req: PayRollRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/generatePayRoll', req)
    .then(res => {
        return res.data;
    })
    
}

async getFreezeMonthInfo(req: PayslipGenerationReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getFreezeMonthInfo', req)
    .then(res => {
        return res.data;
    })
    
}

async saveEmployeePayrollComponent(reqObj: any): Promise<CommonResponse> {
    console.log(reqObj,'aaaaaaaaaaaa')
    return await axios.post(this.URL + '/saveEmployeePayrollComponent',reqObj)
        .then(res => {
            return res.data
        })
}


async getPayrollComponentsData(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getPayrollComponentsData')
        .then(res => {
            return res.data
        })
}


async DeductionExcelUpload(req:any): Promise<CommonResponse> {
    return await axios.post(this.URL + '/DeductionExcelUpload',req)
        .then(res => {
            return res.data
        })
}


async getDeductionsData(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getDeductionsData')
        .then(res => {
            return res.data
        })
}


async getPayrollLogByEmployeeId(req: PayslipGenerationReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getPayrollLogByEmployeeId', req)
        .then(res => {
            return res.data;
        })
}

async getEmployeeDataAgainstYearMonth(req: PayslipGenerationReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getEmployeeDataAgainstYearMonth', req)
        .then(res => {
            return res.data;
        })
    }
    

async getAllPayrollLogs(req: PayRollMonthDto): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getAllPayrollLogs',req)
        .then(res => {
            return res.data
        })
}


async getAllEmployeeEmployeeNamePayrollLogs(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getAllEmployeeEmployeeNamePayrollLogs')
    .then(res => {
        return res.data
    })
}

async updateFreezeStatus(req: PayRollMonthDto): Promise<CommonResponse> {
    console.log(PayRollMonthDto)
    return await axios.post(this.URL + '/updateFreezeStatus',req)
        .then(res => {
            return res.data
        })
}

async getAllNMREmployeeNamePayrollLogs(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getAllNMREmployeeNamePayrollLogs')
        .then(res => {
            return res.data
        })
}

async getAllInHouseEmployeeNamePayrollLogs(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getAllInHouseEmployeeNamePayrollLogs')
        .then(res => {
            return res.data
        })
}



async getPayrollAllData(req?: PayRollRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getPayrollAllData', req)
    .then(res => {
        return res.data
    })
}

async earningsExcelUpload(req:any): Promise<CommonResponse> {
    return await axios.post(this.URL + '/earningsExcelUpload',req)
        .then(res => {
            return res.data
        })
}


async getEarningsData(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getEarningsData')
        .then(res => {
            return res.data
        })
}

async getTdsData(): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getTdsData').then(res=>{
        return res.data
    })
}

async tdsExcelUpload(req:any): Promise<CommonResponse> {
    return await axios.post(this.URL + '/tdsExcelUpload',req)
}

async sendPaySlipMail(req: EmailModel) {
    console.log(req,'---------')
    return await axios.post(this.URL + '/sendPaySlipMail', req)
}

async getEmpTransactionReport(req:employeeIdRequest): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getEmpTransactionReport',req)
}

async getEmpInTransaction(): Promise<CommonResponse> {
    return await axios.get(this.URL + '/getEmpInTransaction')
}

 
}